/* ==========================================================================
   Cart Offer Popup · Checkout Bridge  ·  v2
   AUJ · aujjessa.com

   Intercepts clicks on [data-cart-offer-cta] once the popup is unlocked and
   opens SHOPFLO checkout instead of the CTA's own href.

   Resolution order:
     1. A Shopflo checkout trigger already in the parent document
     2. The same trigger inside a SAME-ORIGIN iframe
     3. A Shopflo JS global (flo / Shopflo / floCheckout ...)
     4. The rendered native checkout button — Shopflo binds its handler to
        native checkout buttons, so clicking this opens Shopflo
     5. Optional: open the cart drawer, poll, then click the trigger
     6. fallbackUrl, only if you set one (empty by default — '/checkout'
        lands on Shopify native, which is the thing we're avoiding)

   A cross-origin #flo-cart-iframe cannot be clicked into by any parent
   script. Steps 3 and 4 are the working paths in that case.

   Diagnostics:  window.CART_OFFER_CHECKOUT_DEBUG = true
                 cartOfferProbe()   // logs triggers, globals, iframes
   ========================================================================== */

(function () {
  'use strict';

  function boot() {
    var holder = document.querySelector('[data-cart-offer-checkout-config]');
    if (!holder || holder.dataset.cartOfferCheckoutReady === '1') return;
    holder.dataset.cartOfferCheckoutReady = '1';

    var cfg;
    try { cfg = JSON.parse(holder.textContent); }
    catch (e) { return; }

    function log() {
      if (!cfg.debug && !window.CART_OFFER_CHECKOUT_DEBUG) return;
      console.log.apply(console, ['[cart-offer-checkout]'].concat([].slice.call(arguments)));
    }

    /* ---------- helpers ---------- */

    function closestEl(node, selector) {
      while (node && node.nodeType === 1) {
        if (node.matches && node.matches(selector)) return node;
        node = node.parentElement;
      }
      return null;
    }

    function isClickable(node, doc) {
      if (!node) return false;
      if (node.disabled) return false;
      if (node.hasAttribute && node.hasAttribute('hidden')) return false;
      if (closestEl(node, '[data-cart-offer-root]')) return false;
      if (closestEl(node, '[data-cart-offer-native]')) return false;

      var view = (doc && doc.defaultView) || window;
      var cs;
      try { cs = view.getComputedStyle(node); } catch (e) { return false; }
      if (!cs) return false;
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      if (parseFloat(cs.opacity) < 0.05) return false;

      var r = node.getBoundingClientRect();
      if (r.width < 8 || r.height < 8) return false;

      return true;
    }

    function toList(str) {
      return String(str || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
    }

    function searchDoc(doc, list) {
      if (!doc) return null;
      var i, j, nodes;

      for (i = 0; i < list.length; i++) {
        try { nodes = doc.querySelectorAll(list[i]); }
        catch (e) { continue; }
        for (j = 0; j < nodes.length; j++) {
          if (isClickable(nodes[j], doc)) {
            log('matched selector', list[i], nodes[j]);
            return nodes[j];
          }
        }
      }

      if (cfg.matchText) {
        var want = String(cfg.matchText).trim().toLowerCase();
        var btns;
        try { btns = doc.querySelectorAll('button,a[role="button"]'); }
        catch (e) { return null; }
        for (i = 0; i < btns.length; i++) {
          var label = (btns[i].textContent || '').trim().toLowerCase();
          if (label && label.indexOf(want) === 0 && isClickable(btns[i], doc)) {
            log('matched text', want, btns[i]);
            return btns[i];
          }
        }
      }

      return null;
    }

    function sameOriginDocs() {
      var out = [];
      if (!cfg.searchIframes) return out;
      var frames = document.querySelectorAll('iframe');
      for (var i = 0; i < frames.length; i++) {
        var doc = null;
        try { doc = frames[i].contentDocument; }
        catch (e) { doc = null; }          // cross-origin, unreachable by design
        if (doc && doc.body) out.push(doc);
        else log('iframe unreachable (cross-origin):', frames[i].id || frames[i].src);
      }
      return out;
    }

    function findCheckout() {
      var list = toList(cfg.selectors);
      var hit = searchDoc(document, list);
      if (hit) return hit;

      var docs = sameOriginDocs();
      for (var i = 0; i < docs.length; i++) {
        hit = searchDoc(docs[i], list);
        if (hit) return hit;
      }
      return null;
    }

    function findCartTrigger() {
      return searchDoc(document, toList(cfg.cartSelectors));
    }

    /* ---------- Shopflo JS API probe ---------- */

    var API_GLOBALS = ['flo', 'Flo', 'shopflo', 'Shopflo', 'ShopFlo', 'floCheckout', 'FloCheckout', '__FLO__', 'FLO'];
    var API_METHODS = ['openCheckout', 'checkout', 'open', 'startCheckout', 'launch', 'show', 'init'];

    function findApi() {
      for (var i = 0; i < API_GLOBALS.length; i++) {
        var obj = window[API_GLOBALS[i]];
        if (!obj) continue;

        if (typeof obj === 'function') {
          return { name: API_GLOBALS[i], obj: window, method: API_GLOBALS[i] };
        }
        for (var j = 0; j < API_METHODS.length; j++) {
          if (typeof obj[API_METHODS[j]] === 'function') {
            return { name: API_GLOBALS[i] + '.' + API_METHODS[j], obj: obj, method: API_METHODS[j] };
          }
        }
      }
      return null;
    }

    function callApi() {
      if (!cfg.tryApi) return false;
      var api = findApi();
      if (!api) return false;
      try {
        api.obj[api.method]();
        log('called API', api.name);
        return true;
      } catch (e) {
        log('API call threw', api.name, e);
        return false;
      }
    }

    /* ---------- native checkout button ---------- */

    function nativeBtn() {
      if (!cfg.nativeForm) return null;
      return document.querySelector('[data-cart-offer-native-btn]');
    }

    function clickNative() {
      var btn = nativeBtn();
      if (!btn) return false;
      try {
        btn.click();
        log('clicked native checkout button — Shopflo should take over');
        return true;
      } catch (e) {
        log('native click threw', e);
        return false;
      }
    }

    /* ---------- diagnostics ---------- */

    window.cartOfferProbe = function () {
      var frames = document.querySelectorAll('iframe');
      console.log('[probe] parent trigger:', findCheckout());
      console.log('[probe] cart trigger:', findCartTrigger());
      console.log('[probe] shopflo API:', findApi());
      console.log('[probe] native button present:', !!nativeBtn());
      console.log('[probe] iframes:', frames.length, 'reachable:', sameOriginDocs().length);
      for (var i = 0; i < frames.length; i++) {
        console.log('[probe] iframe', i, frames[i].id || '(no id)', frames[i].src || '(no src)');
      }
      console.log('[probe] flo-ish globals:', Object.keys(window).filter(function (k) {
        return /flo/i.test(k);
      }));
      return true;
    };

    function fireClick(node) {
      if (!node) return false;
      try {
        node.click();
        log('clicked', node);
        return true;
      } catch (e) {
        log('click threw', e);
        return false;
      }
    }

    function pollThenClick(done) {
      var started = Date.now();
      var every = Math.max(parseInt(cfg.retryEvery, 10) || 150, 60);
      var limit = Math.max(parseInt(cfg.retryFor, 10) || 2500, 0);

      (function tick() {
        var hit = findCheckout();
        if (hit && fireClick(hit)) { done(true); return; }
        if (Date.now() - started >= limit) { done(false); return; }
        setTimeout(tick, every);
      })();
    }

    function goFallback() {
      if (!cfg.fallbackUrl) { log('no fallback url set, stopping here'); return false; }
      log('falling back to', cfg.fallbackUrl);
      window.location.href = cfg.fallbackUrl;
      return true;
    }

    /* ---------- CTA interception ---------- */

    document.addEventListener('click', function (e) {
      var cta = closestEl(e.target, '[data-cart-offer-cta]');
      if (!cta) return;

      var root = closestEl(cta, '[data-cart-offer-root]');
      if (!root) return;

      if (cfg.onlyWhenUnlocked && !root.classList.contains('cart-offer-popup--unlocked')) {
        log('still locked, leaving CTA alone');
        return;
      }

      // From here on the CTA never navigates on its own
      e.preventDefault();
      e.stopPropagation();

      // 1 / 2 — a Shopflo trigger already on the page
      var hit = findCheckout();
      if (hit && fireClick(hit)) return;

      // 3 — Shopflo JS API
      if (callApi()) return;

      // 4 — native checkout button Shopflo has bound itself to
      if (clickNative()) return;

      // 5 — open the cart drawer, then wait for the button to mount
      if (cfg.openCartFirst) {
        var cartBtn = findCartTrigger();
        if (cartBtn) {
          fireClick(cartBtn);
          pollThenClick(function (ok) {
            if (!ok && !clickNative()) goFallback();
          });
          return;
        }
      }

      // 6 — last resort
      goFallback();
    }, true);

    log('ready', cfg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();